module.exports = __webpack_public_path__ + "img/ae.f03dfcea.svg";